<form-control
  [config]="inputConfig"
  [control]="inputControl"
  data-test-id="inputNaField"
>
</form-control>

<form-control
  [group]="formGroup"
  [config]="checkboxConfig"
  [control]="formGroup.get(naProp)"
  data-test-id="inputNACheckbox"
>
</form-control>
